<!-- 房型列表 -->
<template>
  <div class='room_list_wrap'>
    <div
      class="room_list_body"
      v-show="!loading"
    >
      <!-- 区域、时间选择 -->
      <div class="picker_wrap">
        <div class="picker_body">
          <div
            class="picker_time_wrap"
            @click="wannaPickDate"
          >
            <div class="checkin_wrap">
              <div class="week_wrap">
                <div class="week_text">{{ moment(opts.date_checkin).format(`${this.$root.language == 'en' ? 'ddd' :
                  'dddd'}`) }}{{ this.$root.language == 'en' ? '. ' : '' }}</div>
                <div class="tip_text">{{ $t('hotel.checkIn') }}</div>
              </div>
              <div class="date_wrap">{{ moment(opts.date_checkin).format("MMM Do") }}</div>
            </div>
            <div class="checkout_wrap">
              <div class="week_wrap">
                <div class="week_text">{{ moment(opts.date_checkout).format(`${this.$root.language == 'en' ? 'ddd' :
                  'dddd'}`) }}{{ this.$root.language == 'en' ? '. ' : '' }}</div>
                <div class="tip_text">{{ $t('hotel.checkOut') }}</div>
              </div>
              <div class="date_wrap">{{ moment(opts.date_checkout).format("MMM Do") }}</div>
            </div>
          </div>
          <div class="picker_days_wrap">
            <img
              :src="moonImg"
              class="days_bg_img"
            >
            <div class="days_content">
              <div class="days_text">{{ (new Date(opts.date_checkout).getTime() - new Date(opts.date_checkin).getTime()) /
                86400000 }}</div>
              <div class="days_unit">{{ $t('hotel.night') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表内容 -->
      <div class="room_list">
        <div
          class="room_item_wrap"
          v-for="room of rooms"
          :key="room.uid"
        >
          <div
            class="room_cover_wrap"
            v-lazy:background-image="`${apiObj.VUE_APP_BASE_CDN + room.cover[0].url}`"
          >
            <!-- v-lazy:background-image="`${apiObj.VUE_APP_BASE_CDN + room.cover[0].url + '!/fh/200'}`" -->
            <div class="room_cover_footer">
              <div class="room_footer_body">
                <div class="room_name">{{ room.name }}</div>
                <div
                  class="room_detail_btn"
                  @click="handelRoomDetail(room.uid)"
                >{{ $t('hotel.detail') }}</div>
              </div>
            </div>
          </div>
          <div class="room_goods_wrap">
            <div
              class="room_good_item"
              v-for="good of room.products"
              :key="good.uid"
            >
              <div class="good_left">
                <div
                  class="good_name"
                  :style="`lineHeight: ${good.is_with_breakfast ? '1' : '36px'}`"
                >{{ good.name }}</div>
                <div
                  class="good_breakfast"
                  v-if="good.is_with_breakfast"
                >{{ good.with_breakfast ? '含' : '无' }}早餐</div>
              </div>
              <div class="good_price_wrap">
                <div
                  class="good_price"
                  :style="`lineHeight: ${good.is_market_price ? '1' : '36px'}`"
                >{{ opts.currency }}{{ good.price }}</div>
                <div
                  v-if="good.is_market_price"
                  class="good_market_price"
                >{{ $t('hotel.marketPrice') }}{{ opts.currency }}{{ good.market_price ? good.market_price : '' }}</div>
              </div>
              <div
                class="good_btn"
                @click="wannaBooking(room, good)"
              >{{ $t('hotel.bookBtnText') }}</div>
            </div>
          </div>
        </div>
        <!-- 加载全部 -->
        <LoadAll
          v-show="loadall"
          :text="$t('hotel.loadall')"
        />
        <!-- empty -->
        <CusEmpty
          :info="$t('global.empty')"
          v-show="rooms.length == 0"
        />
      </div>
    </div>
    <!-- 加载 -->
    <div
      class="room_list_load_wrap"
      v-show="loading"
    >
      <van-loading
        class="loading_spinner"
        type="spinner"
      />
    </div>

    <!-- 房型详情 -->
    <RoomDetail
      :show="isdetail"
      :roomid="roomid"
      @listenCloseDetail="closeDetail"
    />

    <!-- 日期选择 -->
    <CusCalendar
      :show="isPickDate"
      :start="opts.date_checkin"
      :end="opts.date_checkout"
      :title="$t('hotel.datePickerTitle')"
      @listenCancelCalendar="wannaCancelCalendar"
      @listenConfirmCalendar="confirmDatePick"
    />

  </div>
</template>

<script>
import Vue from 'vue'
import { Lazyload, Loading } from 'vant'
Vue.use(Lazyload)
Vue.use(Loading)

import moment from 'moment'
import 'moment/locale/zh-cn'
import 'moment/locale/en-ca'


import LoadAll from '@c/LoadAll'
import CusEmpty from '@c/CusEmpty'
import RoomDetail from './RoomDetail.vue'
import CusCalendar from '@c/CusCalendar'

import { GetTotalOptions, GetRoomList } from '@a/js/api/booking.js'
import apiObj from '@a/js/api.js'

export default {
  name: 'Rooms',
  data() {
    return {
      moment,
      apiObj,
      moonImg: require('@a/img/home/moon.png'),
      loading: true,
      loadall: false,
      params: {},
      opts: {
        currency: '￥',
        is_active: 0,
        checkin: '',
        checkout: '',
        city: '',
        time_begin: '',
        time_end: ''
      },
      rooms: [],
      roomid: '',
      isdetail: false,
      isPickDate: false,
    };
  },

  components: {
    LoadAll,
    CusEmpty,
    RoomDetail,
    CusCalendar
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise((resolve) => {
        this.params = this.$route.params
        resolve()
      })
    },
    // 跳转酒店预订首页
    jumpToHome() {
      this.$router.push({
        name: "Home",
        params: {
          accountid: this.params.accountid,
          projectid: this.params.projectid,
          language: this.$i18n.locale
        }
      })
    },
    // 获取整体配置
    async wannaTotalOpt() {

      // 获取 home 页面存的配置信息 
      let options = this.$storeLocal.get('cbooking')

      // 如果直接进入页面，未从 home 页面进入，则再次请求配置
      if (!options) {

        // 请求参数
        const params = {
          account_uid: this.params.accountid,
          project_uid: this.params.projectid,
          fields: [
            "is_active",
            "time_begin",
            "time_end",
            "currency",
            "theme",
            "date_checkin",
            "date_checkout",
            "city_options"
          ]
        }

        const res = await GetTotalOptions(params, this.$root.language)

        if (!res.hasOwnProperty('status') || res.status !== 'success') {
          // 请求失败
        }

        // 直接进入页面无法获取当前选择的城市
        // 暂以第一个选项值为默认选中值，没有城市选项或超过 1 个城市选项则返回首页
        if (res.data.city_options.length === 0 || res.data.city_options.length > 1) {
          this.jumpToHome()
          return
        }

        options = res.data
      }

      this.initOptions(options)
      this.initThemeOpt(options.theme)

      await this.wannaRoomList()
    },
    // 设置主体颜色
    initThemeOpt(info) {
      document.body.style.setProperty('--background', info.background)
      document.body.style.setProperty('--color', info.color)
    },
    // 初始化页面配置
    initOptions(info) {
      this.opts.currency = info.currency
      this.opts.is_active = info.is_active
      this.opts.time_begin = info.time_begin
      this.opts.time_end = info.time_end
      this.opts.date_checkin = info.date_checkin
      this.opts.date_checkout = info.date_checkout
      
      if (!info.city) {
        this.opts.city = info.city_options[0].city_zh
      }
    },
    // 查询房型列表
    async wannaRoomList() {
      const params = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        hotel_uid: this.params.hotelid,
        city: this.opts.city,
        date_checkin: this.opts.date_checkin,
        date_checkout: this.opts.date_checkout,
        is_count: 1,
        page: 1,
        page_size: 10,
      }
      const res = await GetRoomList(params, this.$root.language)

      // console.log(res)
      this.rooms = res.data.rooms
      this.loadall = (res.data.count == res.data.rooms) && res.data.count != 0 ? true : false
      this.loading = false

    },
    // 点击预订按钮
    wannaBooking(room, good) {
      let info = {
        roomid: room.uid,
        room_name: room.name,
        cover: room.cover[0].url,
        capacity: room.capacity,
        goodid: good.uid,
        good_name: good.name,
        price: good.price,
        type: good.type,
        checkin: this.opts.date_checkin,
        checkout: this.opts.date_checkout
      }
      this.$emit('listenWannaBook', info)

    },
    // 查看房型详情
    handelRoomDetail(uid) {
      this.roomid = uid
      this.isdetail = true
    },
    // 关闭详情
    closeDetail() {
      this.isdetail = false
    },
    // 点击选择日期
    wannaPickDate() {
      this.isPickDate = true
    },
    // 取消日期选择
    wannaCancelCalendar() {
      this.isPickDate = false
    },
    // 日期选择完成
    confirmDatePick(val) {
      this.isPickDate = false
      this.changeCheckDate(val)
    },
    // 修改入住离店日期
    changeCheckDate(arr) {
      // console.log(moment(arr[0]).format('YYYY-MM-DD'))
      this.opts.date_checkin = moment(arr[0]).format('YYYY-MM-DD')
      this.opts.date_checkout = moment(arr[1]).format('YYYY-MM-DD')
      // 重新查询房型信息
      this.loading = true
      this.wannaRoomList()
    },
  },

  async mounted() {
    moment.locale(this.$i18n.locale == 'zh' ? 'zh-cn' : 'en-ca')

    await this.GetParamsData()

    // 查询整体配置信息
    await this.wannaTotalOpt()
  },
}
</script>
<style lang='less' scoped>
.room_list_wrap {

  // 地区、时间选择
  .picker_wrap {
    width: 100%;
    padding: 15px 0;
    box-sizing: border-box;

    .picker_body {
      height: 60px;
      box-sizing: border-box;
      display: flex;
      background-color: #f7f7f7;
      border-radius: 4px;
      overflow: hidden;

      .picker_time_wrap {
        flex: 1;
        display: flex;

        .checkin_wrap,
        .checkout_wrap {
          flex: 1;
          padding: 10px 0;
          text-align: center;

          .week_wrap {
            font-size: 12px;
            color: #777;
            line-height: 18px;
            font-weight: 600;

            .week_text {
              display: inline-block;
            }

            .tip_text {
              margin-left: 5px;
              display: inline-block;
            }
          }

          .date_wrap {
            font-size: 16px;
            color: #000;
            font-weight: 600;
            line-height: 22px;
          }
        }
      }

      .picker_days_wrap {
        width: 55px;
        position: relative;
        background: #000;

        .days_bg_img {
          position: absolute;
          z-index: 1;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }

        .days_content {
          position: absolute;
          z-index: 2;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          color: #fff;
          font-size: 0;
          width: 100%;
          text-align: center;

          .days_text {
            font-size: 18px;
            font-weight: 600;
            display: inline-block;
          }

          .days_unit {
            font-size: 12px;
            display: inline-block;
          }
        }
      }
    }
  }

  // 房型列表
  .room_list {
    .room_item_wrap {
      margin-bottom: 30px;

      // &:last-child {
      //   margin-bottom: 0;
      // }
      // 封面
      .room_cover_wrap {
        height: 200px;
        box-sizing: border-box;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;

        .room_img_wrap {
          position: absolute;
          z-index: 1;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;

          .room_img {
            height: 200px;
            width: 100%;
          }
        }

        .room_cover_footer {
          position: absolute;
          z-index: 2;
          bottom: 0;
          left: 0;
          right: 0;

          .room_footer_body {
            display: flex;
            padding: 12px 15px;

            .room_name {
              flex: 1;
              margin-right: 15px;
              font-size: 18px;
              line-height: 26px;
              font-weight: 700;
              letter-spacing: 0.01em;
              color: #fff;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space: nowrap;
            }

            .room_detail_btn {
              font-size: 12px;
              letter-spacing: 0.01em;
              font-weight: 700;
              line-height: 26px;
              color: #fff;
            }
          }

          // width: 0;
        }
      }

      // 商品
      .room_goods_wrap {
        .room_good_item {
          margin-top: 20px;
          display: flex;

          .good_left {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 36px;
            margin-right: 15px;
            width: 0;

            .good_name {
              font-size: 16px;
              font-weight: 700;
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space: nowrap;
            }

            .good_breakfast {
              flex: 1;
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
              color: #777;
            }
          }

          .good_price_wrap {
            display: flex;
            flex-direction: column;
            height: 36px;

            .good_price {
              font-size: 20px;
              font-weight: 600;
              text-align: right;
            }

            .good_market_price {
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
              text-align: right;
              color: #777;
              text-decoration: line-through;
            }
          }

          .good_btn {
            margin-left: 10px;
            font-size: 14px;
            padding: 0 14px;
            height: 36px;
            line-height: 36px;
            border-radius: 4px;
            color: var(--color);
            background: var(--background);
          }
        }
      }
    }
  }

  // 记载
  .room_list_load_wrap {
    height: 250px;
    position: relative;

    .loading_spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
</style>